import api from '../api-methods'
import request from "@/api/request";

const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API
const proxyAuth = process.env.VUE_APP_ENV === 'local' ? '/proxy_auth' : process.env.VUE_APP_API_AUTH
const proxyAdmin = process.env.VUE_APP_ENV === 'local' ? '/proxy_admin' : process.env.VUE_APP_ADMIN

const user = {
	// 获取用户账户信息
	getUserAccountInfo: token => {
		return api.get(proxyApi + `/v3/cv_accounts/${token}`)
	},
	// 获取当前用户是否有导师订单
	getUserMentorOrder: payload => {
		return api.get(proxyApi + `/v3/orders/mentor_orders/not_selected_mentor_orders`, payload)
	},
	// 获取当前用户是否导入过简历
	getUserImportCv: (payload, token) => {
		return api.get(proxyApi + `/v3/cv_accounts/${token}/cvs_info_check`, payload)
	},
	// 获取微信js config
	getWeChatJsConfig: payload => {
		return api.get(proxyApi + '/v3/get_wechat_config', payload)
	},
	feedbackSubmit: payload => {
		return api.post(proxyAdmin + '/v1/feedbacks',payload)
	},
	// 获取accout/orders 页面订单数据
	getAccountOrders: token => {
		return api.get(proxyApi + `/v3/cv_accounts/${token}/orders`)
	},
	// 登录获取Udesk在线客服跳转链接
	getUdeskOnlineUrl: payload => {
		return api.get(proxyApi + '/v3/cv_accounts/udesk_settings', payload)
	},
	// 获取accout/users 页面数据
	getAccountUsersInfo: cv_account_token => {
		return api.get(proxyApi + `/v3/cv_accounts/${cv_account_token}/security_settings`)
	},
	// ruby v1接口 直接换成auth v3 先不换 auth v1了,//已更换为v3，此接口废弃
	updateInfo: payload => {
		return api.post(proxyApi + '/v1/account/users/update_info', payload)
	},
	cancelOrder: payload => {
		return api.delete(proxyApi + `/v3/cv_accounts/${payload.cv_account_token}/orders/${payload.order_token}`, payload)
	},
	submitUserAvatar: payload => {
		return api.put(proxyApi + `/v3/cv_accounts/${payload.cv_account_token}`, payload)
	},
	// 退出登录 不用去掉 带sign_out的不会走到ruby项目 权限系统会拦下 直接清除cookie
	signOut: payload => {
		return api.post(proxyApi + `/v2/cv_accounts/sign_out`, payload)
	},
	// 获取屏蔽公司列表
	getBlockingCompanies: payload => {
		return api.get(proxyApi + '/v3/jobs/blocking_companies', payload)
	},
	// 删除屏蔽公司
	deleteBlockingCompany: token => {
		return api.delete(proxyApi + `/v3/jobs/blocking_companies/${token}`)
	},
	// 添加屏蔽公司
	addBlockCompany: token => {
		return api.post(proxyApi + `/v3/jobs/blocking_companies/${token}`)
	},
	// 获取用户账户信息
	getAccountInfoByAuth: user_token => {
		return api.get(proxyAuth + `/v3/users/${user_token}`)
	},
	// 优惠券对象接口
	getAccountSpecialOffers: (cv_account_token, payload) => {
		return api.get(`${proxyApi}/v3/cv_accounts/${cv_account_token}/special_offers`, payload)
	},
	// 兑换优惠券
	setSpecialOffers: (cv_account_token, payload) => {
		return api.post(`${proxyApi}/v3/cv_accounts/${cv_account_token}/invitations`, payload)
	},
	// 获取机构号信息
	getGroupMessage: token => {
		return api.get(`${proxyApi}/v3/groups/${token}`)
	},
	// 机构号邀请新用户绑定
	setGroupUserSignUp: payload => {
		return api.post(`${proxyApi}/v3/auth/group_users/sign_up`,payload)
  },
	// 创建新的会员订单
	createSuperOrder: payload => {
		return api.post(`${proxyApi}/v3/orders/improved_orders`, payload)
	},
	// 更新会员订单
	updateSuperOrder: (token, payload) => {
		return api.put(`${proxyApi}/v3/orders/improved_orders/${token}`, payload)
	},
	// 创建预付订单(0元购买)
	freeMoneyBuyMember: (token, payload) => {
		return api.post(`${proxyApi}/v3/orders/improved_orders/${token}/pay`, payload)
	},
	// 获取机构号邀请二维码
	getGroupInvitationQrcode: payload => {
		return api.post(`${proxyApi}/v3/tools/wechat_qrcodes`,payload)
	},
	// 获取个人设置隐私设置
	getPersonPrivacy: token => {
		return api.get(`${proxyApi}/v3/cv_accounts/${token}/privacy`)
	},
	// 个人设置隐私设置
	setPersonPrivacy: (token, payload) => {
		return api.post(`${proxyApi}/v3/cv_accounts/${token}/privacy`, payload)
	},
	// 获取机构号组队信息
	getGroupTeam:(payload) => {
		// console.log(payload)
		return api.get(`${proxyApi}/v3/groups_user/captain_info`,payload)
	},
	//绑定用户并创建队伍
	bingUser:(payload) => {
		return api.post(`${proxyApi}/v3/groups_user/groups_qr`,payload)
	},
	// 获取用户购买的订单状态
	getPurchaseRecordData: (payload) => {
		return api.get(`${proxyApi}/v3/improved_orders/purchase_record`, payload)
	}
}

export default user
